import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ErrorStore, StridesStoreItem } from '@sleipai/sleip-models';
import * as AnalysisStridesActions from '../actions/analysis-strides.actions';

export const analysisStridesesFeatureKey = 'analysisStrideses';

export interface State extends EntityState<StridesStoreItem> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<StridesStoreItem> =
  createEntityAdapter<StridesStoreItem>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const analysisStridesReducer = createReducer(
  initialState,
  on(AnalysisStridesActions.loadAnalysisStridesByIdAndPublicKey, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(AnalysisStridesActions.loadAnalysisStridesById, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(AnalysisStridesActions.loadAnalysisStridesSuccess, (state, { data }) =>
    adapter.upsertOne(data, {
      ...state,
      loaded: true,
      loading: false,
    })
  ),
  on(AnalysisStridesActions.loadAnalysisStridesFailure, (state, { error }) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      error: {
        message: error['message'],
        status: error['status'],
      },
    };
  })
);

export const {
  selectIds: selectAnalysisStridesIdsAdapter,
  selectEntities: selectAnalysisStridesEntitiesAdapter,
  selectAll: selectAllAnalysisStridesAdapter,
  selectTotal: selectAnalysisStridesTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return analysisStridesReducer(state, action);
}
